import { cn } from "@/lib/utils";
import { forwardRef, ReactNode } from "react";

export type FieldProps = {
    id?: string;
    name?: string;
    label?: string;
    labelPosition?: "before" | "after";
    required?: boolean;
    children?: ReactNode;
    node?: unknown;
    type: string;
    value?: string;
    checked?: boolean;
    files?: FileList;
    onChange?: (newValue: { value: string, checked: boolean, files: FileList }) => void;
    disabled?: boolean;
};

const Field = forwardRef<HTMLInputElement, FieldProps>((props, ref) => {
    const { type = "text", id, name, label, labelPosition = "after", required, onChange, value: propValue, disabled, node: _, ...rest } = props;

    const inputId = id || name;
    if (!inputId) {
        console.warn("Field is missing an id");
    }

    return (
        <div className={cn(
            "flex flex-row items-center gap-2 text-base",
            labelPosition === "before" && "flex-row-reverse justify-end"
        )}>
            <input
                {...rest}
                ref={ref}
                id={inputId}
                name={name}
                type={type}
                required={required}
                onChange={(e) => {
                    onChange?.({
                        value: e.currentTarget.value,
                        checked: e.currentTarget.checked,
                        files: e.currentTarget.files,
                    });
                }}
                disabled={disabled}
            />
            {label && (
                <label htmlFor={inputId} className="text-base">
                    {label}
                </label>
            )}
        </div>
    );
});

export { Field };